import React, { useState, useEffect } from 'react';


const CustomVideoPlayer = ({...props}) =>
  {
    const [videoID, setVideoID] = useState(0);

    //there has to be a better way to do this without loading the script multiple times
    useEffect(() => {      
      if(props.videoID == videoID) return; //if its the same video ID dont reload the player (this already happens on the react level I think)

      setVideoID(props.videoID);

      const script = document.createElement('script');
    
      script.src = "//control.resi.io/webplayer/loader.min.js";
      script.async = true;
    
      document.body.appendChild(script);
    
      return () => {
        document.body.removeChild(script);
      }
    }, [props.videoID]);

    return (
      <div className="embed-container">
          <div id="resi-video-player" data-embed-id={videoID}></div>  
      </div>
    )
  }



export default CustomVideoPlayer;